import React from 'react';
import { Marker } from 'react-leaflet';
import L from 'leaflet';

// Custom icon for gyms
const createGymIcon = (team, badgeLevel, inBattle, totalCP, slots) => {
  // Get team color
  let color = '#757575'; // No team (gray)
  if (team === 1) color = '#0055cc'; // Blue
  if (team === 2) color = '#bb0000'; // Red
  if (team === 3) color = '#bb9900'; // Yellow
  
  // Get badge color
  let badgeColor = 'transparent';
  if (badgeLevel === 1) badgeColor = '#cd7f32'; // Bronze
  if (badgeLevel === 2) badgeColor = '#c0c0c0'; // Silver
  if (badgeLevel === 3) badgeColor = '#ffd700'; // Gold
  
  // Create battle effect
  const battleEffect = inBattle ? `gym-marker-battle` : ``;
  
  // Create badge ring
  const badgeRing = badgeLevel > 0 ?
    `border: 4px solid ${badgeColor};` : 
    '';
	
  const slotsLine = slots > 0 ?
    `<div class="gym-label slots">${slots}</div>` :
    '';
	
  const totalCPLine = slots > 0 ?
    `<div class="gym-label total-cp">${totalCP}</div>` :
    '';
  
  const size = 30;
  
  return L.divIcon({
    html: `
      ${slotsLine}
      <div class="gym-marker" style="background-color: ${color}; ${badgeRing}; width:${size}px; height:${size}px">
        <div class="gym-icon"></div>
      </div>
      ${totalCPLine}
	`,
    className: `custom-gym-marker ${battleEffect}`,
    iconSize: [size, size],
    iconAnchor: [18, 18]
  });
};

const GymMarker = ({ gym, onClick }) => {
  const icon = createGymIcon(gym.team, gym.badge_level || 0, gym.in_battle, gym.total_cp, 6 - gym.slots_available);
  
  return (
    <Marker
      position={[gym.latitude, gym.longitude]}
      icon={icon}
      eventHandlers={{
        click: onClick
      }}
    >
    </Marker>
  );
};

export default GymMarker;